import { Box, Heading } from '@chakra-ui/react';
import Stats from './Stats';

function Home() {
  return (
    <Box>
      <Heading>Good afternoon, Daniel!</Heading>
      <Stats mt={6} />
    </Box>
  );
}

export default Home;
